var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch, Prop } from "vue-facing-decorator";
import { SystemsClient, GetSystemViewPaginatedQuery, PaginatedEnumerableOfSystemQuery, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import Sorter from "@/common/utils/sorter";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import RouteNames from "@/app/router/routes";
const systemsClient = new SystemsClient(window.apiUrl);
let CompanySystemsVue = class CompanySystemsVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        // NOTE: companyId is assigned in created() because with vue-facing-decorator v4
        // class field initializers run before @Prop values are bound on the instance.
        this.query = new GetSystemViewPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            showUnhealthyOnly: false,
            companyId: null
        });
        this.data = new PaginatedEnumerableOfSystemQuery();
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SystemName",
            direction: SortDirection.Ascending
        }));
    }
    // methods
    created() {
        this.query.companyId = this.companyId;
        this.search();
    }
    ;
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        this.working = true;
        systemsClient
            .search(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // set
    edit(system) {
        this.$router.push({ name: RouteNames.System, params: { id: system.systemId.toString() } });
    }
    ;
    archive(system) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this system?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            systemsClient
                .delete(system.systemId)
                .then(() => {
                system.whenDeleted = new Date();
                Notifier.onOk(`System # ${system.systemId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(system) {
        if (this.working)
            return;
        systemsClient
            .restore(system.systemId)
            .then(() => {
            system.whenDeleted = undefined;
            Notifier.onOk(`System # ${system.systemId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    reload() {
        this.search();
    }
    ;
    // computed
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanySystemsVue.prototype, "companyId", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySystemsVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySystemsVue.prototype, "onSortChanged", null);
CompanySystemsVue = __decorate([
    Component({
        name: "CompanySystemsVue",
        expose: ["reload"],
    })
], CompanySystemsVue);
export default CompanySystemsVue;
